import type { WorkspaceTerm } from '@/features/workspace-terms/types';

const DAY_MS = 86_400_000;

export const getCurrentTerm = (terms: WorkspaceTerm[]) => terms.find((term) => term.isCurrent);

export const getTermNumber = (terms: WorkspaceTerm[], term: WorkspaceTerm) =>
  terms.length - terms.indexOf(term);

export const getRemainingWorkspaces = (term: WorkspaceTerm) =>
  Math.max(0, term.includedWorkspaces - term.createdWorkspaces);

export const getTermUsage = (term: WorkspaceTerm) =>
  term.includedWorkspaces > 0 ? term.createdWorkspaces / term.includedWorkspaces : 1;

export const getTermLengthMonths = (term: WorkspaceTerm) =>
  Math.round((Date.parse(term.endsOn) + DAY_MS - Date.parse(term.startsOn)) / (30.44 * DAY_MS));

export const getWorkspaceLimit = (term: WorkspaceTerm) => {
  if (term.createdWorkspaces >= term.includedWorkspaces) return 'reached';
  if (term.createdWorkspaces >= term.includedWorkspaces * 0.75) return 'near';
  return null;
};

export const getTermStatus = (term: WorkspaceTerm) => {
  if (term.createdWorkspaces > term.includedWorkspaces) return 'over';
  if (term.isCurrent) return 'current';
  if (Date.parse(term.startsOn) > Date.now()) return 'upcoming';
  if (term.createdWorkspaces === term.includedWorkspaces) return 'fullyUsed';
  return 'ended';
};
